import ReactDOMServer from 'react-dom/server';
import sanitizeHtml from 'sanitize-html';

import { IAccordionData } from '../../../../../components/Accordion/Accordion';
import { IFAQSchema } from '../../../../../helpers/schema';

export const getFAQMetaData = (faqData: IAccordionData[]): IFAQSchema[] => {
  return faqData.map(({ title, body }) => ({
    name: sanitizeHtml(typeof title === 'string' ? title : ReactDOMServer.renderToString(title)),
    acceptedAnswer: sanitizeHtml(
      typeof body === 'string' ? body : ReactDOMServer.renderToString(body),
    ),
  }));
};
